import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { api } from '../../lib/api';
import { SectionLabel, Reveal } from '../Section';
import TournamentCard from '../TournamentCard';

export default function Matches() {
  const [list, setList] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () =>
      api
        .tournaments()
        .then((d) => {
          if (alive) setList((d.tournaments || []).filter((t) => t.status !== 'completed').slice(0, 6));
        })
        .catch(() => {
          if (alive) setList([]);
        });
    load();
    const i = setInterval(load, 60000);
    return () => {
      alive = false;
      clearInterval(i);
    };
  }, []);

  return (
    <section className="py-20 sm:py-28" data-testid="matches-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex items-end justify-between gap-6">
          <SectionLabel testid="matches-label">Live and Upcoming Matches</SectionLabel>
          <Link
            to="/tournaments"
            data-testid="matches-see-all-link"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-bold text-[#e8173a] hover:gap-3 transition-all duration-300 shrink-0"
          >
            See All <ArrowRight className="w-4 h-4" strokeWidth={2.6} />
          </Link>
        </div>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {list === null
            ? Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="h-44 rounded-xl bg-[#1a1f2e] animate-pulse" data-testid={`matches-skeleton-${i}`} />
              ))
            : list.map((t, i) => <TournamentCard key={t.id} t={t} index={i} />)}
        </div>
        {list !== null && list.length === 0 && (
          <Reveal className="mt-10">
            <p className="text-[#8a8a8a] text-sm" data-testid="matches-empty">No live or upcoming matches right now. New tournaments drop daily.</p>
          </Reveal>
        )}
        <div className="mt-8 sm:hidden">
          <Link to="/tournaments" data-testid="matches-see-all-link-mobile" className="inline-flex items-center gap-1.5 text-sm font-bold text-[#e8173a]">
            See All <ArrowRight className="w-4 h-4" strokeWidth={2.6} />
          </Link>
        </div>
      </div>
    </section>
  );
}
